/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.notification

import kotlinx.serialization.Serializable

@Serializable
data class NotificationPreferences(
    val sessionRemindersEnabled: Boolean = false,
    val paymentRemindersEnabled: Boolean = false,
    val sessionAdvanceMinutes: Int = 60,
    val paymentReminderDayOfWeek: Int = 1,
    val paymentReminderHour: Int = 9,
    val paymentReminderMinute: Int = 0,
    val permissionRequested: Boolean = false,
) {
    companion object {
        val DEFAULT = NotificationPreferences()
    }
}
